
import PlayerViewPage from '../../pages/Player/index'
import PlayerNoVerificationViewPage from '../../pages/Player/indexNoVerification'
import Feedback from '../../pages/Player/feedback'
// export default {
//     Player:{
//         component: PlayerViewPage,
//         path: '/Course/Play/:id/:sectionId'
//     }
// };

export default {
    Player:{
        component: PlayerViewPage,
        path: '/mycourses/:id/'
    },
    PlayerNoVerification:{
        component: PlayerNoVerificationViewPage,
        path: '/mycoursesv/:id/'
    },
    Feedback:{
        component: Feedback,
        path: '/mycourses/feedback/:id/'
    }
};